// Auth Pages
import Login from './Auth/Login.jsx';
import Register from './Auth/Register.jsx';
import PasswordResetNew from './Auth/PasswordResetNew.jsx';
import PasswordResetEdit from './Auth/PasswordResetEdit.jsx';
import EmailVerificationPending from './Auth/EmailVerificationPending.jsx';
import InvitationShow from './Auth/InvitationShow.jsx';
import SalesDealsIndex from './Sales/Deals/Index.jsx';
import SalesDealsNew from './Sales/Deals/New.jsx';
import SalesDealsShow from './Sales/Deals/Show.jsx';
import SalesLogin from './Sales/Login.jsx';
import SalesLoginLinkSent from './Sales/LoginLinkSent.jsx';
import ReviewerLogin from './Reviewer/Login.jsx';
import ReviewerLoginLinkSent from './Reviewer/LoginLinkSent.jsx';
import InstructorLogin from './Instructor/Login.jsx';
import InstructorLoginLinkSent from './Instructor/LoginLinkSent.jsx';

// Dashboard
import Dashboard from './Dashboard.jsx';
import Profile from './Profile.jsx';
import Certificates from './Certificates.jsx';
import Webinars from './Webinars.jsx';
import WebinarEvaluation from './WebinarEvaluation.jsx';
import WebinarRoom from './WebinarRoom.jsx';

// Facilities
import FacilityNew from './Facilities/New.jsx';
import FacilityShow from './Facilities/Show.jsx';
import FacilityEdit from './Facilities/Edit.jsx';
import FacilityUserProgress from './Facilities/UserProgress.jsx';
import FacilityInviteUser from './Facilities/InviteUser.jsx';
import FacilityBilling from './Facilities/Billing.jsx';
import FacilityPurchaseLicense from './Facilities/PurchaseLicense.jsx';

// Student Purchase
import StudentPurchaseNew from './StudentPurchase/New.jsx';
import StudentPurchaseBilling from './StudentPurchase/Billing.jsx';

// Group Training Manager
import TeamIndex from './Team/Index.jsx';
import ProgressIndex from './Progress/Index.jsx';
import AssignTrainingIndex from './AssignTraining/Index.jsx';
import DocumentsIndex from './Documents/Index.jsx';

// Buy Flow (legacy single-page - kept for completion handler)
import BuyComplete from './Buy/Complete.jsx';
import DealsShow from './Deals/Show.jsx';
import SuperadminDealsIndex from './Superadmin/Deals/Index.jsx';
import SuperadminDealsNew from './Superadmin/Deals/New.jsx';
import SuperadminDealsShow from './Superadmin/Deals/Show.jsx';

// Signup Flow (URL-routed steps)
import SignupIndex from './Signup/Index.jsx';
import SignupGroupBuyer from './Signup/Group/Buyer.jsx';
import SignupGroupFacility from './Signup/Group/Facility.jsx';
import SignupGroupTraining from './Signup/Group/Training.jsx';
import SignupGroupCheckout from './Signup/Group/Checkout.jsx';
import SignupIndividualBuyer from './Signup/Individual/Buyer.jsx';
import SignupIndividualRole from './Signup/Individual/Role.jsx';
import SignupIndividualTraining from './Signup/Individual/Training.jsx';
import SignupIndividualFacility from './Signup/Individual/Facility.jsx';
import SignupIndividualReview from './Signup/Individual/Review.jsx';
import SignupIndividualCheckout from './Signup/Individual/Checkout.jsx';

// Clinical Review
import ClinicalReviewNew from './ClinicalReview/New.jsx';
import ClinicalReviewShow from './ClinicalReview/Show.jsx';

// Support
import SupportIndex from './Support/Index.jsx';
import SupportNew from './Support/New.jsx';
import SupportShow from './Support/Show.jsx';

// Superadmin
import SuperadminDashboard from './Superadmin/Dashboard.jsx';
import SuperadminUsers from './Superadmin/Users.jsx';
import SuperadminUserDetail from './Superadmin/UserDetail.jsx';
import SuperadminOAuthApps from './Superadmin/OAuthApps.jsx';
import SuperadminOAuthAppNew from './Superadmin/OAuthAppNew.jsx';
import SuperadminAnnouncementsIndex from './Superadmin/Announcements/Index.jsx';
import SuperadminAnnouncementsNew from './Superadmin/Announcements/New.jsx';
import SuperadminAnnouncementsEdit from './Superadmin/Announcements/Edit.jsx';
import SuperadminNabDomainsIndex from './Superadmin/NabDomains/Index.jsx';
import SuperadminNabDomainsNew from './Superadmin/NabDomains/New.jsx';
import SuperadminNabDomainsEdit from './Superadmin/NabDomains/Edit.jsx';
import SuperadminSalesRepsIndex from './Superadmin/SalesReps/Index.jsx';
import SuperadminSalesRepsShow from './Superadmin/SalesReps/Show.jsx';
import SuperadminSalesRepsNew from './Superadmin/SalesReps/New.jsx';
import SuperadminSalesRepsEdit from './Superadmin/SalesReps/Edit.jsx';
import SuperadminReviewersIndex from './Superadmin/Reviewers/Index.jsx';
import SuperadminReviewersShow from './Superadmin/Reviewers/Show.jsx';
import SuperadminReviewersNew from './Superadmin/Reviewers/New.jsx';
import SuperadminReviewersEdit from './Superadmin/Reviewers/Edit.jsx';
import SuperadminInstructorsIndex from './Superadmin/Instructors/Index.jsx';
import SuperadminInstructorsShow from './Superadmin/Instructors/Show.jsx';
import SuperadminInstructorsNew from './Superadmin/Instructors/New.jsx';
import SuperadminInstructorsEdit from './Superadmin/Instructors/Edit.jsx';
import SuperadminAdminCoursesIndex from './Superadmin/AdminCourses/Index.jsx';
import SuperadminAdminCoursesShow from './Superadmin/AdminCourses/Show.jsx';
import SuperadminAdminCoursesNew from './Superadmin/AdminCourses/New.jsx';
import SuperadminAdminCoursesEdit from './Superadmin/AdminCourses/Edit.jsx';
import SuperadminCoursesIndex from './Superadmin/Courses/Index.jsx';
import SuperadminCoursesShow from './Superadmin/Courses/Show.jsx';
import SuperadminCourseReviewsIndex from './Superadmin/CourseReviews/Index.jsx';
import SuperadminCourseReviewsShow from './Superadmin/CourseReviews/Show.jsx';
import SuperadminLicenseMappingsIndex from './Superadmin/LicenseMappings/Index.jsx';
import SuperadminLicenseMappingsEdit from './Superadmin/LicenseMappings/Edit.jsx';
import SuperadminEmailJourneysIndex from './Superadmin/EmailJourneys/Index.jsx';
import SuperadminEmailJourneysNew from './Superadmin/EmailJourneys/New.jsx';
import SuperadminEmailJourneysEdit from './Superadmin/EmailJourneys/Edit.jsx';
import SuperadminSourcesIndex from './Superadmin/Sources/Index.jsx';
import SuperadminSourcesNew from './Superadmin/Sources/New.jsx';
import SuperadminSupportTicketsIndex from './Superadmin/SupportTickets/Index.jsx';
import SuperadminSupportTicketsShow from './Superadmin/SupportTickets/Show.jsx';
import SuperadminWebinarsIndex from './Superadmin/Webinars/Index.jsx';
import SuperadminWebinarsNew from './Superadmin/Webinars/New.jsx';
import SuperadminWebinarsEdit from './Superadmin/Webinars/Edit.jsx';
import SuperadminWebinarsShow from './Superadmin/Webinars/Show.jsx';
import SuperadminWebinarsBroadcast from './Superadmin/Webinars/Broadcast.jsx';
import SuperadminWebinarRecordings from './Superadmin/Webinars/Recordings.jsx';
import SuperadminWebinarAttendance from './Superadmin/Webinars/Attendance.jsx';
import SuperadminWebinarAttendanceDetail from './Superadmin/Webinars/AttendanceDetail.jsx';
import SuperadminBroadcastRecording from './Superadmin/Webinars/BroadcastRecording.jsx';

export const Pages = {
  'Auth/Login': Login,
  'Auth/Register': Register,
  'Auth/PasswordResetNew': PasswordResetNew,
  'Auth/PasswordResetEdit': PasswordResetEdit,
  'Auth/EmailVerificationPending': EmailVerificationPending,
  'Auth/InvitationShow': InvitationShow,
  'Sales/Deals/Index': SalesDealsIndex,
  'Sales/Deals/New': SalesDealsNew,
  'Sales/Deals/Show': SalesDealsShow,
  'Sales/Login': SalesLogin,
  'Sales/LoginLinkSent': SalesLoginLinkSent,
  'Reviewer/Login': ReviewerLogin,
  'Reviewer/LoginLinkSent': ReviewerLoginLinkSent,
  'Instructor/Login': InstructorLogin,
  'Instructor/LoginLinkSent': InstructorLoginLinkSent,
  // The instructor broadcast page reuses the same React component as the
  // superadmin host UI; the controller passes chromeless + back_link props
  // to swap the chrome (no admin nav, "Back to dashboard" link).
  'Instructor/Broadcast': SuperadminWebinarsBroadcast,
  'Dashboard': Dashboard,
  'Profile': Profile,
  'Certificates': Certificates,
  'Webinars': Webinars,
  'WebinarEvaluation': WebinarEvaluation,
  'WebinarRoom': WebinarRoom,
  'Facilities/New': FacilityNew,
  'Facilities/Show': FacilityShow,
  'Facilities/Edit': FacilityEdit,
  'Facilities/UserProgress': FacilityUserProgress,
  'Facilities/InviteUser': FacilityInviteUser,
  'Facilities/Billing': FacilityBilling,
  'Facilities/PurchaseLicense': FacilityPurchaseLicense,
  'StudentPurchase/New': StudentPurchaseNew,
  'StudentPurchase/Billing': StudentPurchaseBilling,
  'Team/Index': TeamIndex,
  'Progress/Index': ProgressIndex,
  'AssignTraining/Index': AssignTrainingIndex,
  'Documents/Index': DocumentsIndex,
  'Buy/Complete': BuyComplete,
  'Deals/Show': DealsShow,
  'Superadmin/Deals/Index': SuperadminDealsIndex,
  'Superadmin/Deals/New': SuperadminDealsNew,
  'Superadmin/Deals/Show': SuperadminDealsShow,
  'Signup/Index': SignupIndex,
  'Signup/Group/Buyer': SignupGroupBuyer,
  'Signup/Group/Facility': SignupGroupFacility,
  'Signup/Group/Training': SignupGroupTraining,
  'Signup/Group/Checkout': SignupGroupCheckout,
  'Signup/Individual/Buyer': SignupIndividualBuyer,
  'Signup/Individual/Role': SignupIndividualRole,
  'Signup/Individual/Training': SignupIndividualTraining,
  'Signup/Individual/Facility': SignupIndividualFacility,
  'Signup/Individual/Review': SignupIndividualReview,
  'Signup/Individual/Checkout': SignupIndividualCheckout,
  'ClinicalReview/New': ClinicalReviewNew,
  'ClinicalReview/Show': ClinicalReviewShow,
  'Support/Index': SupportIndex,
  'Support/New': SupportNew,
  'Support/Show': SupportShow,
  'Superadmin/Dashboard': SuperadminDashboard,
  'Superadmin/Users': SuperadminUsers,
  'Superadmin/UserDetail': SuperadminUserDetail,
  'Superadmin/OAuthApps': SuperadminOAuthApps,
  'Superadmin/OAuthAppNew': SuperadminOAuthAppNew,
  'Superadmin/Announcements/Index': SuperadminAnnouncementsIndex,
  'Superadmin/Announcements/New': SuperadminAnnouncementsNew,
  'Superadmin/Announcements/Edit': SuperadminAnnouncementsEdit,
  'Superadmin/NabDomains/Index': SuperadminNabDomainsIndex,
  'Superadmin/NabDomains/New': SuperadminNabDomainsNew,
  'Superadmin/NabDomains/Edit': SuperadminNabDomainsEdit,
  'Superadmin/SalesReps/Index': SuperadminSalesRepsIndex,
  'Superadmin/SalesReps/Show': SuperadminSalesRepsShow,
  'Superadmin/SalesReps/New': SuperadminSalesRepsNew,
  'Superadmin/SalesReps/Edit': SuperadminSalesRepsEdit,
  'Superadmin/Reviewers/Index': SuperadminReviewersIndex,
  'Superadmin/Reviewers/Show': SuperadminReviewersShow,
  'Superadmin/Reviewers/New': SuperadminReviewersNew,
  'Superadmin/Reviewers/Edit': SuperadminReviewersEdit,
  'Superadmin/Instructors/Index': SuperadminInstructorsIndex,
  'Superadmin/Instructors/Show': SuperadminInstructorsShow,
  'Superadmin/Instructors/New': SuperadminInstructorsNew,
  'Superadmin/Instructors/Edit': SuperadminInstructorsEdit,
  'Superadmin/AdminCourses/Index': SuperadminAdminCoursesIndex,
  'Superadmin/AdminCourses/Show': SuperadminAdminCoursesShow,
  'Superadmin/AdminCourses/New': SuperadminAdminCoursesNew,
  'Superadmin/AdminCourses/Edit': SuperadminAdminCoursesEdit,
  'Superadmin/Courses/Index': SuperadminCoursesIndex,
  'Superadmin/Courses/Show': SuperadminCoursesShow,
  'Superadmin/CourseReviews/Index': SuperadminCourseReviewsIndex,
  'Superadmin/CourseReviews/Show': SuperadminCourseReviewsShow,
  'Superadmin/LicenseMappings/Index': SuperadminLicenseMappingsIndex,
  'Superadmin/LicenseMappings/Edit': SuperadminLicenseMappingsEdit,
  'Superadmin/EmailJourneys/Index': SuperadminEmailJourneysIndex,
  'Superadmin/EmailJourneys/New': SuperadminEmailJourneysNew,
  'Superadmin/EmailJourneys/Edit': SuperadminEmailJourneysEdit,
  'Superadmin/Sources/Index': SuperadminSourcesIndex,
  'Superadmin/Sources/New': SuperadminSourcesNew,
  'Superadmin/SupportTickets/Index': SuperadminSupportTicketsIndex,
  'Superadmin/SupportTickets/Show': SuperadminSupportTicketsShow,
  'Superadmin/Webinars/Index': SuperadminWebinarsIndex,
  'Superadmin/Webinars/New': SuperadminWebinarsNew,
  'Superadmin/Webinars/Edit': SuperadminWebinarsEdit,
  'Superadmin/Webinars/Show': SuperadminWebinarsShow,
  'Superadmin/Webinars/Broadcast': SuperadminWebinarsBroadcast,
  'Superadmin/Webinars/Recordings': SuperadminWebinarRecordings,
  'Superadmin/Webinars/Attendance': SuperadminWebinarAttendance,
  'Superadmin/Webinars/AttendanceDetail': SuperadminWebinarAttendanceDetail,
  'Superadmin/Webinars/BroadcastRecording': SuperadminBroadcastRecording,
};
